import { Text } from 'components';
import React from 'react';
import { TableComponents } from 'screens/Admin/components';
import TierAssignmentsListItem from './TierAssignmentsListItem';

const TierAssignmentsList = ({ data, onClick, dataId, loading, teams }) => {
  return (
    <TableComponents.List
      maxTableHeight="40vh"
      minTableHeight={data?.length && '250px'}
      loading={loading}
      Header={() => (
        <React.Fragment>
          <TableComponents.Th first width100>
            <Text wid="200px">Athlete</Text>
          </TableComponents.Th>

          <TableComponents.Th width100>
            <Text wid="200px">Team</Text>
          </TableComponents.Th>

          <TableComponents.Th width100>
            <Text wid="200px">Sport</Text>
          </TableComponents.Th>

          <TableComponents.Th width100>
            <Text wid="200px">Tier</Text>
          </TableComponents.Th>

          <TableComponents.Th last width100>
            <Text wid="50px"></Text>
          </TableComponents.Th>
        </React.Fragment>
      )}
      Items={() =>
        !loading && data
          ? data.map((item, i) => {
              const team = teams.find((team) => team._id === item?.playerInfo?.teamId);

              return (
                <TierAssignmentsListItem
                  key={i}
                  dataId={dataId}
                  onClick={onClick}
                  item={{
                    ...item,
                    playerInfo: {
                      ...item.playerInfo,
                      teamName: team && team.name
                    }
                  }}
                />
              );
            })
          : null
      }
    />
  );
};

export default TierAssignmentsList;
